import wixLocation from 'wix-location';
import wixData from 'wix-data';

$w.onReady(function () {
	// Redirect to a product's dynamic page.
	$w('#productPage1').getProduct()
		.then((product) => {
			let productSku = product.sku;
			console.log(productSku)
			let url = product.slug;
			if (productSku > 999) {
				$w('#productPage1').hide();
				if (productSku>8000) {
				wixLocation.to(`/stores/maraz/${url}`);	
				} else {
				wixLocation.to(`/products/${url}`);	
				}
				console.log(url);
			}
		})
		.catch((error) => {
			console.log(error);
		});
	//design
	//$w('#clearmenu').hide();
	//$w('#whitemenu').show();
});


//----------Hide loading image on regular product page-----//
export function productPage1_viewportEnter(event) {
	$w('#loadingImage').hide();
}